import * as echarts from "echarts"

export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  grid: {
    top: "20%",
    left: "10%",
    right: "10%",
    bottom: "10%",
  },
  tooltip: {
    trigger: "none",
    axisPointer: {
      type: "cross",
    },
  },
  legend: [
    {
      show: true,
      icon: "bar",
      textStyle: {
        color: "rgba(255,255,255,0.65)",
      },
      itemStyle: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#2BD2F7", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(43,210,247,0.5)", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },
      },
      data: ["Evaporation"],
      left: "5%",
    },
    {
      show: true,
      icon: "roundRect",
      textStyle: {
        color: "rgba(255,255,255,0.65)",
      },
      itemStyle: {
        color: "#DADADA",
      },
      data: ["Temperature"],
      right: "5%",
    },
  ],
  xAxis: [
    {
      show: false,
      type: "category",
      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisPointer: {
        label: {
          backgroundColor: "rgba(76, 145, 246, 1)",
        },
      },
    },
    {
      show: false,
      type: "category",
      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisPointer: {
        label: {
          backgroundColor: "rgba(82, 204, 197, 1)",
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      alignTicks: true,
      name: "",
      axisLabel: {
        formatter: "{value}",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
        },
      },
    },
    {
      type: "value",
      alignTicks: true,
      name: "",
      axisLabel: {
        formatter: "{value}",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
        },
      },
    },
  ],
  series: [
    {
      name: "Evaporation",
      type: "bar",
      showBackground: true,
      barWidth: 9,
      itemStyle: {
        borderRadius: [4, 4, 0, 0],
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: "#2BD2F7" },
          { offset: 1, color: "rgba(43,210,247,0.5)" },
        ]),
      },
      data: [14.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
    },
    {
      name: "Temperature",
      type: "line",
      xAxisIndex: 1,
      yAxisIndex: 1,
      smooth: true,
      symbol: "none",
      lineStyle: {
        color: "#DADADA",
      },
      data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
    },
  ],
  graphic: [{}],
}
